import DragonbonesComponent from "Component/Dragonbones";
import FarmEffectComponent from "Component/Farm/FarmEffect";
import { FarmEffectHelper } from "Component/Farm/FarmEffectHelper";
import TransformComponent from "Component/Transform";
import Game from "Game";
import Armature from "Prototype/Armature";
import { StartAnimationClip } from "System/Animation/AnimationHelper";
import { DragonbonesFadeIn } from "System/Animation/Clip";
import { ILimit } from "Utility/MathHelper";
import { Random } from "Utility/Random";
import { FarmEffectData } from "./FarmEffectData";

const initialAnimationDelayLimits: ILimit = { min: 50, max: 1000 };

export class FarmEnvironmentEffect extends Armature {
    private timeout: () => void;

    onCreate(data: FarmEffectData) {
        const intervalData = (data.intervalRange) ? {
            playTimes: 1,
        } : {};

        super.onCreate({
            playOnStart: false,
            alpha: 0,
            ...intervalData,
            ...data
        });
        
        this.addComponent(FarmEffectComponent, data);
        this.setTimeout(Random.range(initialAnimationDelayLimits));
    }

    public readonly show = (): void => {
        if (this.destroyed) return;

        const effectComponent = this.getComponent(FarmEffectComponent);
        const transformComponent = this.getComponent(TransformComponent);
        const dragonbonesComponent = this.getComponent(DragonbonesComponent);

        // Setup next iteration
        if (effectComponent.intervalRange) {
            this.setTimeout(FarmEffectHelper.getRandomIntervalTime(effectComponent));
        }
        
        setPosition();
        
        const animationName = Random.getRandomItem(effectComponent.animationNames) ?? dragonbonesComponent.animationName;
        // Play animation - concat false as first frame of animation is not blank and concat causes undesirable fading effects in this case
        StartAnimationClip(new DragonbonesFadeIn(this, { animationName, concat: false }));

        return;

        function setPosition(): void {
            const x = effectComponent.x + FarmEffectHelper.getRandomXOffset(effectComponent);
            const y = effectComponent.y + FarmEffectHelper.getRandomYOffset(effectComponent);

            transformComponent.position.set(x, y);
        }
    }

    private clearTimeout(): void {
        if (this.timeout) {
            Game.ticker.clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    private setTimeout(time: number): void {
        this.clearTimeout();
        this.timeout = Game.ticker.setTimeout(this.show, time);
    }

    public destroy() {
        this.clearTimeout();
        super.destroy();
    }
}